import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Rol } from '../models';

/** Pantalla inicial según el rol del usuario. */
export function homePorRol(rol: Rol | null): string {
  switch (rol) {
    case 'repartidor':
      return '/repartos';
    case 'almacen':
      return '/picking';
    default:
      return '/dashboard';
  }
}

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.autenticado() ? true : router.parseUrl('/login');
};

/** Redirige la raíz a la home del rol. */
export const homeGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.autenticado()) return router.parseUrl('/login');
  return router.parseUrl(homePorRol(auth.rol()));
};

/**
 * Restringe una ruta a determinados roles (admin siempre pasa). Al denegar
 * redirige a la home del rol — nunca a una ruta que pueda volver a denegar,
 * o el router entraría en bucle.
 */
export const rolGuard = (...roles: Rol[]): CanActivateFn => () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.autenticado()) return router.parseUrl('/login');
  if (auth.tieneRol(...roles)) return true;
  const home = homePorRol(auth.rol());
  return router.parseUrl(home === '/dashboard' && !auth.tieneRol('gerente', 'director_comercial', 'comercial')
    ? '/clientes'
    : home);
};
